module.exports = __webpack_public_path__ + "img/vitality-money-Bronze.2dc2460f.svg";